import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";
import type { Tone } from "@/tokens";
import { warningSurfaceTextStyle } from "../warningVisual";

export type TipProps = HTMLAttributes<HTMLSpanElement> & {
  tone?: Tone;
};

const toneClassName: Record<Tone, string> = {
  neutral: "bfrs-bg-surface-muted bfrs-text-text-secondary",
  primary: "bfrs-bg-primary-soft bfrs-text-primary",
  brand: "bfrs-bg-primary-soft bfrs-text-primary",
  success: "bfrs-bg-success-soft bfrs-text-success-contrast",
  warning: "",
  danger: "bfrs-bg-danger-soft bfrs-text-danger-contrast",
  info: "bfrs-bg-info-soft bfrs-text-info-contrast"
};

export const Tip = forwardRef<HTMLSpanElement, TipProps>(({ className, tone = "primary", style, ...props }, ref) => (
  <span ref={ref} className={cn("bfrs-inline-flex bfrs-min-h-5 bfrs-items-center bfrs-rounded-pill bfrs-px-2 bfrs-text-[11px] bfrs-font-semibold bfrs-leading-5", toneClassName[tone], className)} style={{ ...(tone === "warning" ? warningSurfaceTextStyle : undefined), ...style }} {...props} />
));

Tip.displayName = "Tip";
